import images from 'assets/images/images'
import React from 'react'
import {FormattedNumber, IntlProvider} from 'react-intl';
import {  useLocation } from 'react-router-dom';
import auth from 'utils/Auth';

const NavbarCard = ({ getAllBasket }) => {
  const parameters = auth.getUserChoises();
  const location = useLocation()
  return (
    auth.isHaveToken() && (parameters?.deliveryType &&
      parameters?.neighbourhoodId &&
      parameters?.restaurantId &&
      (parameters?.deliveryType != 2 || parameters?.regionId)) && <a href={location.pathname == '/odeme' ? '#detay' : '/odeme'} className='navbar-card'>
      <img src={images.basket} alt="" />
      <div className='navbar-card-total'>{ <IntlProvider locale={'tr'} defaultLocale="en">
      <FormattedNumber
        maximumFractionDigits={2}
        minimumFractionDigits={2}
        value={getAllBasket?.orderTotal ? getAllBasket?.orderTotal : 0}
        style={'decimal'}
      />
    </IntlProvider>}TL</div>
      <div className='navbar-card-count'>{getAllBasket?.items?.length ? getAllBasket?.items?.length : 0}</div>
    </a>
  )
}

export default NavbarCard